module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-5.dea42381.jpg";